export default function (files, targetFile) {
	const realTargetFile = targetFile.file || targetFile;
	return files.findIndex((file) => {
		const realFile = file.file || file;
		if (realFile.filename === realTargetFile.filename) {
			return true;
		}
	});
}
